import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import CollaboratorsStats from'./CollaboratorsStats.js';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrash, faEdit, faEye } from "@fortawesome/free-solid-svg-icons";
 const token = localStorage.getItem('token');
const CollaboratorsList = () =>{
    const[collaborators, setCollaborators] =useState([]);
    const navigate = useNavigate();
    useEffect(()=> {
        fetchCollaborators();
    },[]);
    const fetchCollaborators = async()=>{
        try{
            const res = await axios.get("/collaborator", {
                headers: { Authorization: `Bearer ${token}` },
            });
            const nonDeleted = res.data.filter((p)=>p.deletedAt === null);
            setCollaborators(nonDeleted);
            console.log("data", nonDeleted)
        }catch (error){
            console.error("Erreur lors du chargement des collaborators")
        }};
    const handleDelete =async (id)=>{
        try{await axios.delete(`/collaborator/${id}`,{
            headers:{
                Authorization:
                `Bearer ${token}`,},});
            fetchCollaborators();}
            catch(error){
                console.error("Erreur lors de la suppression", error);
            }}
    return(
    <div className="dashboard-container">
      {/* Top Bar */}
      <div className="top-bar">
        <h3>Gestion des collaborateurs</h3>
        <div>
          <button onClick={() => navigate("/admin/collaborators/new")} className="bout-new">
            <FontAwesomeIcon icon={faPlus} style={{ marginRight: "8px" }} />
            Nouveau collaborateur
          </button>

          <button onClick={() => navigate("/admin/collaborators/trash")} className="bout-trash">
            <FontAwesomeIcon icon={faTrash} style={{ marginRight: "8px" }} />
            Corbeille
          </button>
        </div>
      </div>

      
      {/* Tableau */}
      <div className="liste p-4">
        <h3 className="listeh">Liste des collaborateurs</h3>
        <table className="w-full border mt-2">
          <thead className="bg-gray-100">
            <tr>
              <th className="p-2 border">Nom</th>
              <th className="p-2 border">E-mail</th>
              <th className="p-2 border">Poste </th>
              <th className="p-2 border">PositionJEI</th>
              <th className="p-2 border">Projets associés</th>
              <th className="p-2 border">Actions</th>

            </tr>
          </thead>
          <tbody>
            {collaborators.length > 0 ? (
              collaborators.map((collaborator) => (
                <tr key={collaborator.id} className="text-center">
                  <td className="p-2 border">{collaborator.name}</td>
                  <td className="p-2 border">{collaborator.email}</td>
                  <td className="p-2 border">{collaborator.jobTitle}</td>
                  <td className="p-2 border">{collaborator.positionJEI}</td>
                  <td className="p-2 border">
                  <ul>
                    {collaborator.projects.map((p) => (
                      <li key={p.id}>{p.projectName}</li>))}
                  </ul>
                  </td>
                  <td className="p-2 border space-x-2">
                    <button
                      onClick={() => navigate(`/admin/collaborators/${collaborator.id}`)}
                      className="icon-button text-blue-600"
                    >
                      <FontAwesomeIcon icon={faEye} />
                    </button>
                    <button
                      onClick={() => navigate(`/admin/collaborators/${collaborator.id}/edit`)}
                      className="icon-button text-green-600"
                    >
                      <FontAwesomeIcon icon={faEdit} />
                    </button>
                    <button
                      onClick={() => handleDelete(collaborator.id)}
                      className="icon-button text-red-600"
                    >
                      <FontAwesomeIcon icon={faTrash} />
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td className="text-center p-4" colSpan={6}>
                  
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
<CollaboratorsStats/>
      
    </div>);};
    export default CollaboratorsList;
        